async function send(url, { method = 'GET', csrfToken, body, errorMessage }) {
  try {
    const headers = { 'Content-Type': 'application/json' }
    if (csrfToken) {
      headers['X-CSRF-Token'] = csrfToken
    }
    const res = await fetch(url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    })
    const data = await res.json()
    if (res.status >= 400) {
      return { error: data.Error || errorMessage, errorCode: res.status }
    }
    return { data: data.Data }
  } catch (e) {
    console.error(errorMessage, e)
    return { error: errorMessage }
  }
}

function withQuery(path, params) {
  const query = new URLSearchParams()
  for (const key in params) {
    if (params[key]) {
      query.set(key, params[key])
    }
  }
  const search = query.toString()
  return search ? `${path}?${search}` : path
}

export async function fetchComments({ orgID, status, limit, offset }) {
  const { data, error, errorCode } = await send(
    withQuery('/api/admin/comments', { orgID, status, limit, offset }),
    { errorMessage: 'Error while fetching comments. Please try again in sometime.' },
  )
  return { comments: data?.Comments || [], counts: data?.Counts || {}, error, errorCode }
}

export async function fetchComment({ orgID, commentID }) {
  const { data, error, errorCode } = await send(
    withQuery(`/api/admin/comments/${commentID}`, { orgID }),
    { errorMessage: 'Error while fetching the comment. Please try again in sometime.' },
  )
  return { comment: data, error, errorCode }
}

export async function createComment(csrfToken, comment) {
  const { data, error } = await send('/api/admin/comments', {
    method: 'POST',
    csrfToken,
    body: comment,
    errorMessage: 'Error while saving the comment. Please try again in sometime.',
  })
  return { comment: data, error }
}

export async function updateComment(csrfToken, comment) {
  const { data, error } = await send(`/api/admin/comments/${comment.ID}`, {
    method: 'POST',
    csrfToken,
    body: comment,
    errorMessage: 'Error while saving the comment. Please try again in sometime.',
  })
  return { comment: data, error }
}

export async function deleteComment(csrfToken, comment) {
  const { error } = await send(`/api/admin/comments/${comment.ID}`, {
    method: 'DELETE',
    csrfToken,
    errorMessage: 'Error while deleting the comment. Please try again in sometime.',
  })
  return { error }
}

export async function deleteCommentTarget(csrfToken, comment, target) {
  const { error } = await send(`/api/admin/comments/${comment.ID}/targets/${target.ID}`, {
    method: 'DELETE',
    csrfToken,
    errorMessage: 'Error while deleting the comment. Please try again in sometime.',
  })
  return { error }
}

export async function fetchMyCommentTargets({ orgID, statuses }) {
  const { data, error, errorCode } = await send(
    withQuery('/api/me/comment-targets', { orgID, statuses: statuses?.join(',') }),
    { errorMessage: 'Error while fetching comments. Please try again in sometime.' },
  )
  return { commentTargets: data || [], error, errorCode }
}

export async function approveCommentTarget(csrfToken, target) {
  const { error } = await send(`/api/comment-targets/${target.ID}/approve`, {
    method: 'POST',
    csrfToken,
    errorMessage: 'Error while approving the comment. Please try again in sometime.',
  })
  return { error }
}

export async function rejectCommentTarget(csrfToken, target, rejectionNotes) {
  const { error } = await send(`/api/comment-targets/${target.ID}/reject`, {
    method: 'POST',
    csrfToken,
    body: { RejectionNotes: rejectionNotes },
    errorMessage: 'Error while rejecting the comment. Please try again in sometime.',
  })
  return { error }
}
